/**
 * FIORELLE — Announcement Bar Enhanced
 * ─────────────────────────────────────
 * Funciones:
 *  1. Mensajes dinámicos (nueva visita vs recurrente)
 *  2. Detección de cliente logueado
 *  3. Efecto shimmer dorado en texto
 *  4. Botón de cierre con localStorage
 *
 * NO modifica slideshow-component ni auto_rotate nativo de Rise
 */

(function () {
  'use strict';

  const CONFIG = {
    storageKey:   'fiorelle_returning',
    closedKey:    'fiorelle_bar_closed',
    closedExpiry: 24 * 60 * 60 * 1000,
    shimmerColor1: '#C9A84C',
    shimmerColor2: '#F0D080',
    shimmerColor3: '#C9A84C',
  };

  const MESSAGES_NEW = [
    'Fiorelle, brillo que habla por ti ✨',
    'Diseños pensados para acompañar cada versión de ti ✨',
    'Pequeños detalles que reflejan quién eres ✨',
    'Tu esencia merece piezas que hablen por ti ✨'
  ];

  const MESSAGES_RETURNING = [
    'Nos encanta tenerte de vuelta ✨',
    'Siempre hay nuevas piezas esperándote ✨',
    'Descubre algo que combine contigo hoy ✨',
    'Bienvenida otra vez a Fiorelle ✨'
  ];

  const MESSAGES_LOGGED_IN = [
    'Hola de nuevo, tu estilo nos inspira ✨',
    'Nuevas piezas esperan por ti ✨',
    'Tu próxima favorita ya está aquí ✨',
    'Bienvenida a tu espacio Fiorelle ✨'
  ];

  function isBarClosed() {
    const closed = localStorage.getItem(CONFIG.closedKey);
    if (!closed) return false;
    return (Date.now() - parseInt(closed, 10)) < CONFIG.closedExpiry;
  }

  function hideBar(barSection) {
    barSection.style.transition = 'opacity 0.3s ease, max-height 0.4s ease';
    barSection.style.opacity = '0';
    setTimeout(() => {
      barSection.style.maxHeight = '0';
      barSection.style.overflow = 'hidden';
    }, 300);
  }

  function addCloseButton(barSection) {
    const btn = document.createElement('button');
    btn.setAttribute('aria-label', 'Cerrar anuncio');
    btn.setAttribute('type', 'button');
    btn.className = 'fiorelle-bar-close';
    btn.innerHTML = '&times;';
    btn.addEventListener('click', function () {
      localStorage.setItem(CONFIG.closedKey, Date.now().toString());
      hideBar(barSection);
    });
    const grid = barSection.querySelector('.utility-bar__grid');
    if (grid) grid.appendChild(btn);
  }

  function getActiveMessages(isLoggedIn) {
    if (isLoggedIn) return MESSAGES_LOGGED_IN;
    return localStorage.getItem(CONFIG.storageKey)
      ? MESSAGES_RETURNING
      : MESSAGES_NEW;
  }

  function replaceMessages(isLoggedIn) {
    const spans = document.querySelectorAll('.announcement-bar__message span');
    if (!spans.length) return;
    const messages = getActiveMessages(isLoggedIn);
    spans.forEach(function (span, index) {
      if (messages[index] !== undefined) {
        span.textContent = messages[index];
      }
    });
    localStorage.setItem(CONFIG.storageKey, 'true');
  }

  function applyShimmer() {
    const style = document.createElement('style');
    style.id = 'fiorelle-shimmer-style';
    style.textContent = `
      .announcement-bar__message span {
        background: linear-gradient(
          90deg,
          ${CONFIG.shimmerColor1} 0%,
          ${CONFIG.shimmerColor2} 40%,
          #ffffff 50%,
          ${CONFIG.shimmerColor2} 60%,
          ${CONFIG.shimmerColor3} 100%
        );
        background-size: 250% auto;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
        animation: fiorelle-shimmer 4s linear infinite;
        display: inline-block;
      }
      @keyframes fiorelle-shimmer {
        0%   { background-position: 200% center; }
        100% { background-position: -200% center; }
      }
      .fiorelle-bar-close {
        position: absolute;
        right: 12px;
        top: 50%;
        transform: translateY(-50%);
        background: transparent;
        border: none;
        color: currentColor;
        font-size: 18px;
        line-height: 1;
        cursor: pointer;
        opacity: 0.6;
        padding: 4px 8px;
        transition: opacity 0.2s ease;
        z-index: 10;
      }
      .fiorelle-bar-close:hover { opacity: 1; }
      .utility-bar { position: relative; }
    `;
    document.head.appendChild(style);
  }

  function isCustomerLoggedIn() {
    return document.body.dataset.customerLoggedIn === 'true';
  }

  function init() {
    const barSection = document.querySelector('.announcement-bar-section');
    if (!barSection) return;
    if (isBarClosed()) {
      hideBar(barSection);
      return;
    }
    const loggedIn = isCustomerLoggedIn();
    applyShimmer();
    replaceMessages(loggedIn);
    addCloseButton(barSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
